import type { HostPublicProfile } from '@/mocks/hostProfile';

interface Props {
  profile: HostPublicProfile;
}

export default function HostProgramsSection({ profile }: Props) {
  const colors = ['from-rose-500 to-rose-400', 'from-amber-500 to-amber-400', 'from-emerald-500 to-emerald-400', 'from-sky-500 to-sky-400', 'from-violet-500 to-violet-400'];

  return (
    <section id="programas" className="scroll-mt-24">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-calendar-schedule-line text-accent-500"></i>
          Programas
        </h2>
        <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-full">
          {profile.programs.length} {profile.programs.length === 1 ? 'programa' : 'programas'}
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {profile.programs.map((program, idx) => (
          <div
            key={idx}
            className="group bg-white rounded-xl border border-foreground-100 overflow-hidden hover:shadow-sm transition-all cursor-pointer"
          >
            <div className="flex items-stretch">
              <div className={`w-2 flex-shrink-0 bg-gradient-to-b ${colors[idx % colors.length]}`}></div>
              <div className="flex-1 p-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mic-line text-accent-600 text-lg"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-foreground-950 text-sm group-hover:text-accent-600 transition-colors">{program.name}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5 flex items-center gap-1">
                      <i className="ri-time-line text-[10px]"></i>
                      {program.schedule}
                    </p>
                  </div>
                  <button className="flex-shrink-0 w-8 h-8 rounded-lg bg-background-50 hover:bg-accent-100 flex items-center justify-center text-foreground-400 hover:text-accent-600 transition-all cursor-pointer">
                    <i className="ri-add-line text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}